import { Container } from "@mui/material";
import { DataStoreBreadcrumbs } from "~/components/DataStoreBreadcrumbs";
import { Page } from "~/components/Page";
import { WorkflowCreateForm } from "./components/WorkflowCreateForm";

export function NewWorkflowPage() {
  return (
    <Page title="New Workflow">
      <Container fixed>
        <DataStoreBreadcrumbs />
        <WorkflowCreateForm />
      </Container>
    </Page>
  );
}
